/**
 * News Analytics Tracking
 *
 * Google Analytics 4 event tracking for news/announcements feature
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

/**
 * Track news article view
 */
export function trackNewsView(params: {
  news_id: string;
  news_category: string;
  news_title: string;
  is_authenticated: boolean;
}) {
  if (window.gtag) {
    window.gtag('event', 'view_news_item', params);
  }
}

/**
 * Track news CTA button click
 */
export function trackNewsCTA(params: {
  news_id: string;
  cta_url: string;
  cta_text: string;
}) {
  if (window.gtag) {
    window.gtag('event', 'click_news_cta', params);
  }
}

/**
 * Track news social share
 */
export function trackNewsShare(params: {
  news_id: string;
  share_platform: 'twitter' | 'facebook' | 'linkedin';
}) {
  if (window.gtag) {
    window.gtag('event', 'share_news', params);
  }
}

/**
 * Track RSS subscription
 */
export function trackRSSSubscribe(params: { rss_url: string }) {
  if (window.gtag) {
    window.gtag('event', 'subscribe_rss', params);
  }
}
